import { EntityTypeId } from "../../../../core/entity/EntityTypeId.enum"
import type { Entity } from "../../../../core/entity/index"
import { next } from "../../../../core/rng/index"
import tmpRngWith from "../../../../core/rng/tmpRngWith"
import { min } from "../../../../core/util/math/Math"

/**
 * Determines if an entity should have grass waves based on RNG and distance to land.
 * For sea and river tiles, grass probability decreases with distance from land.
 * 
 * @param ent - The entity to check
 * @param distanceToLand - Manhattan distance to nearest land tile (0 = land, 1+ = sea/river)
 * @returns true if the entity should have grass waves
 */
export default function rngSaysEntHasGrassWaves(
  ent: Entity,
  distanceToLand: number = 0
): boolean {
  const { etype_id, id } = ent
  const rngResult = next(tmpRngWith(id))

  if (etype_id === EntityTypeId.Desert) {
    return rngResult < 0.4
  }
  // if (etype_id === EntityTypeId.Forest) {
  //   return rng < 0.3
  // }
  if (etype_id === EntityTypeId.Plain) {
    return rngResult < 0.9
  }
  // if (etype_id === EntityTypeId.Mountain) {
  //   return rng < 0.5
  // }
  if (etype_id === EntityTypeId.Lake) {
    return rngResult < 0.9
  }
  if (etype_id === EntityTypeId.Marsh) {
    return true
  }
  if (etype_id === EntityTypeId.River) {
    // River grass probability decreases with distance from land
    // Base probability 0.4, reduced by 0.1 per distance unit
    const baseProbability = 0.4
    const distancePenalty = min(distanceToLand * 0.1, 0.35) // Cap penalty at 0.35
    return rngResult < (baseProbability - distancePenalty)
  }
  if (etype_id === EntityTypeId.Sea) {
    // Sea grass probability decreases more aggressively with distance from land
    // Base probability 0.2, reduced by 0.05 per distance unit
    // const baseProbability = 0.2
    // const distancePenalty = min(distanceToLand * 0.05, 0.18) // Cap penalty at 0.18

    const probability = 2 / ((2 + distanceToLand) * (1 + distanceToLand))
    // console.log('rngResult', rngResult, 'distanceToLand', distanceToLand, 'probability', probability)

    return rngResult < probability
  }
  if (etype_id === EntityTypeId.Shoal) {
    return rngResult < 0.1
  }
  return false
}

// setTimeout(() => {
//   console.table([0, 1, 2, 3, 4, 5, 6, 7].map((distanceToLand) => {
//     return {
//       distanceToLand,
//       probability: 2 / ((2 + distanceToLand) * (1 + distanceToLand)),
//     }
//   }))
// }, 100)